

import React from 'react';

import './index.scss';

function Item({
    info,
    current
}) {
    function toJump() {
        window.locationTo({
            url: info.jumpUrl
        })
    }
    return (
        <div 
            className='home-fare-item' 
            style={{backgroundImage: 'url('+info.img+')'}} 
            onClick={toJump}
            clstag={`rwxqy|banner${current+1}`}
        >
            <div>{info.mainTitle}</div>
            <div>{info.subTitle}</div>
        </div>
    )
}


export default React.memo(Item);